const BackgroundTaskStatus = {
  NotStarted: 1,
  Processing: 3,
  Processed: 4,
  FailedProcessing: 5
};

export default BackgroundTaskStatus;
